import { render } from "./app-form-switch.vue?vue&type=template&id=49792bd6"
import script from "./app-form-switch.vue?vue&type=script&lang=js"
export * from "./app-form-switch.vue?vue&type=script&lang=js"

import "./app-form-switch.vue?vue&type=style&index=0&id=49792bd6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49792bd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49792bd6', __exports__)) {
    console.log('reload')
    api.reload('49792bd6', __exports__)
  }
  
  module.hot.accept("./app-form-switch.vue?vue&type=template&id=49792bd6", () => {
    console.log('re-render')
    api.rerender('49792bd6', render)
  })

}


export default __exports__